import type React from "react";

export const WeightLiftingIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      {...restProps}
    >
      <title>Weight lifting icon</title>
      <g>
        <path
          d="M495.841 101.383h-13.617V55.788a8.537 8.537 0 0 0-8.537-8.537h-23.323a8.537 8.537 0 0 0-8.537 8.537v45.595h-29.811c1.243-13.058-8.373-24.492-21.113-25.839-13.105-1.382-24.726 8.197-26.09 21.099l-.501 4.739h-41.088c-12.121 26.171-38.282 43.068-67.261 43.068-29.378 0-55.317-17.281-67.261-43.068h-40.938l-.501-4.739c-1.375-12.998-13.102-22.474-26.09-21.1-12.723 1.347-22.358 12.768-21.113 25.841H70.171V55.789a8.537 8.537 0 0 0-8.537-8.537H38.311a8.537 8.537 0 0 0-8.537 8.537v45.595H16.159C7.234 101.383 0 108.617 0 117.542c0 8.924 7.234 16.159 16.159 16.159h13.616v45.595a8.537 8.537 0 0 0 8.537 8.537h23.323a8.537 8.537 0 0 0 8.537-8.537v-45.595h33.291c1.023 9.669 8.253 78.036 9.321 88.147 2.145 20.289 27.705 28.867 41.462 13.117l33.346-38.161v90.784l-86.282 35.055a30.852 30.852 0 0 0-18.886 23.93L65.21 459.425c-2.57 16.845 9.002 32.582 25.846 35.151s32.582-9.002 35.151-25.846l14.572-95.523 79.818-32.429h70.854l79.818 32.429 14.572 95.523c2.57 16.846 18.307 28.415 35.151 25.846 16.844-2.57 28.415-18.307 25.846-35.151l-17.215-112.853a30.854 30.854 0 0 0-18.886-23.93l-86.966-35.334V195.99l34.055 38.974c13.39 15.326 39.255 7.732 41.462-13.117l9.323-88.147h33.217v45.595a8.537 8.537 0 0 0 8.537 8.537h23.323a8.537 8.537 0 0 0 8.537-8.537V133.7h13.617c8.924 0 16.159-7.234 16.159-16.159-.001-8.924-7.235-16.158-16.16-16.158zm-341.58 61.447-3.081-29.13h28.534a270490.066 270490.066 0 0 1-25.453 29.13zm203.551 0-25.454-29.13h28.534l-3.08 29.13z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <circle
          cx="255.963"
          cy="70.351"
          r="53.284"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></circle>
      </g>
    </svg>
  );
};
